import {
  IonContent,
  IonPage,
  IonSkeletonText,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonRow,
  IonSearchbar,
} from '@ionic/react';
import { useState, useEffect, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import axios from '../../axios';
import Header from '../../components/Header';
import NoRecords from '../../components/NoRecords';
import { AppContext } from '../../providers/AppContext';

const MaintenaceHistory: React.FC = () => {
  const isMounted = useRef(true);

  const [data, setData] = useState<any>({
    dataSet: [],
  });

  const { state } = useContext(AppContext);

  const [isLoading, setIsLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(0);

  const [disableInfiniteScroll, setDisableInfiniteScroll] = useState<boolean>(false);
  const [searchText, setSearchText] = useState('');


  const getData = (context: any) => {
    console.log(context)
    isMounted.current = true; // Set isMounted to true
    let url = `/method/preflet_asset.api.get_assigned_maintenance?limit=${state.maxLength}&start=${context.isFiltered ? 0 : currentPage * 5 + 0
      }`;



    // add search data if any
    if ('search' in context || searchText) {
      if (isMounted.current)
        setSearchText(context.search || '');
      if (context.search) url += `&search=${context.search || searchText}`;
    }

    const config: any = {
      method: 'get',
      url,
      headers: {
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    };
    axios(config)
      .then((res: any) => {
        console.log(res)
        if (res?.data && res.data?.message && res.data.message?.maintenance_list?.length > 0) {
          if (context.isFiltered) {
            const rawData = { dataSet: [], loading: false };
            rawData.dataSet = res.data.message?.maintenance_list;
            if (isMounted.current)
              setData(rawData);
          } else {
            const Data = { ...data };

            Data.dataSet.push(...res.data.message?.maintenance_list);
            if (isMounted.current)
              setData(Data);
          }
          if (isMounted.current)
            setDisableInfiniteScroll(res.data.message?.maintenance_list.length < state.maxLength);
        } else {

          if (isMounted.current)
            setDisableInfiniteScroll(true);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        if (isMounted.current) {
          setIsLoading(false);
          setCurrentPage(currentPage + 1);
        }
      });
  };

  useEffect(() => {

    getData({});

    // Cleanup function
    return () => {
      isMounted.current = false; // Mark the component as unmounted when it's being cleaned up
      // You can also cancel any subscriptions or clean up other resources here
    };
  }, []);

  // ion-refersher
  // function doRefresh(event: CustomEvent<RefresherEventDetail>) {
  //   getData({});
  //   setTimeout(() => {
  //     event.detail.complete();
  //   }, 2000);
  // }

  function searchNext($event: CustomEvent<void>) {
    getData({});

    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  const { t } = useTranslation();

  const handleSearch = (value: any) => {
    getData({ search: value, isFiltered: true });
  }

  return (
    <IonPage>
      <Header enableBackButton='/maintenanceHome' title={t('Maintenance.History.History')} />
      <IonContent fullscreen={true}>

        {/* ── Hero / Search bar ── */}
        <div style={{
          background: 'linear-gradient(135deg, #1d508d 0%, #2a6db5 100%)',
          padding: '16px 14px 14px',
        }}>
          <p style={{ margin: '0 0 10px', fontSize: '11px', color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
            {t('Maintenance.History.History')}
          </p>
          <div style={{
            display: 'flex', alignItems: 'center', gap: '10px',
            background: 'rgba(255,255,255,0.15)',
            borderRadius: '12px',
            padding: '8px 12px',
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.8)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input
              type="text"
              value={searchText}
              onChange={(e) => handleSearch(e.target.value)}
              placeholder={t('Utils.filter') + '...'}
              style={{
                background: 'transparent', border: 'none', outline: 'none',
                color: '#fff', fontSize: '14px', flex: 1,
              }}
            />
            {searchText && (
              <span onClick={() => handleSearch('')} style={{ color: 'rgba(255,255,255,0.7)', cursor: 'pointer', fontSize: '18px', lineHeight: 1 }}>×</span>
            )}
          </div>
        </div>

        {/* ── Skeleton loaders ── */}
        {isLoading && [1, 2, 3, 4, 5, 6].map((el) => (
          <div key={el} style={{ margin: '10px 12px', borderRadius: '14px', background: '#fff', padding: '14px 16px', boxShadow: '0 3px 14px rgba(0,0,0,0.06)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <IonSkeletonText animated style={{ width: '50%', height: '14px', borderRadius: '8px' }} />
              <IonSkeletonText animated style={{ width: '20%', height: '14px', borderRadius: '8px' }} />
            </div>
            <IonSkeletonText animated style={{ width: '35%', height: '10px', borderRadius: '8px' }} />
          </div>
        ))}

        {/* ── Maintenance cards ── */}
        <div style={{ padding: '10px 12px 80px' }}>
          {data.dataSet?.map((item: any, key: any) => {
            const isOverdue = item.target_date &&
              new Date(item.target_date).toLocaleDateString() < new Date().toLocaleDateString();

            return (
              <Link
                key={key}
                to={{ pathname: '/maintainanceDetail', state: item.name }}
                style={{ textDecoration: 'none' }}
              >
                <div style={{
                  background: '#fff',
                  borderRadius: '14px',
                  boxShadow: '0 4px 18px rgba(0,0,0,0.07)',
                  marginBottom: '10px',
                  padding: '14px 16px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                }}>
                  {/* Left accent bar */}
                  <div style={{
                    width: '4px', alignSelf: 'stretch', borderRadius: '4px',
                    background: isOverdue ? '#e53935' : '#1d508d',
                    flexShrink: 0,
                  }} />

                  {/* Info */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <p style={{ margin: 0, fontSize: '14px', fontWeight: 700, color: '#1a2a3a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {item.name}
                    </p>
                    <p style={{ margin: '2px 0 6px', fontSize: '11px', color: '#6b7b8f', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {t('Assets.Details.AID')}: {item.asset || '—'}
                    </p>
                    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', alignItems: 'center' }}>
                      {item.doctype && (
                        <span style={{
                          background: '#f0f4ff',
                          color: '#4a6fa5',
                          borderRadius: '20px', padding: '2px 10px',
                          fontSize: '10px', fontWeight: 700,
                        }}>
                          {t(`Utils.${item.doctype}`)}
                        </span>
                      )}
                      {item.men_status && (
                        <span style={{
                          background: '#eef4fd',
                          color: '#1d508d',
                          borderRadius: '20px', padding: '2px 10px',
                          fontSize: '10px', fontWeight: 700,
                        }}>
                          {item.men_status}
                        </span>
                      )}
                      {isOverdue && (
                        <span style={{
                          background: '#fdecea', color: '#e53935',
                          borderRadius: '20px', padding: '2px 10px',
                          fontSize: '10px', fontWeight: 700,
                        }}>
                          {t('Assets.Details.overdue')}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Arrow */}
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#b0c4de" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </div>
              </Link>
            );
          })}

          {/* Empty state */}
          {!isLoading && data.dataSet.length === 0 && (
            <IonRow>
              <NoRecords width="60%" smallText={false} />
            </IonRow>
          )}
        </div>

        <IonInfiniteScroll disabled={disableInfiniteScroll} onIonInfinite={(e: CustomEvent<void>) => searchNext(e)}>
          <IonInfiniteScrollContent loadingSpinner="bubbles" loadingText={t('Utils.pleasewait')} />
        </IonInfiniteScroll>
      </IonContent>
    </IonPage>
  );
};

export default MaintenaceHistory;
